export const MANAGER_PATHS = ["/dashboard", "/opzioni", "/calendario", "/money", "/fatture", "/fattura", "/trasferimenti", "/disponibilita", "/report", "/affitti", "/staff", "/spese-guesthouse", "/amministrazione", "/mira", "/voucher", "/ricevuta"];

export const managerAllowed = (path) => path === "/" || MANAGER_PATHS.some((p) => path === p || path.startsWith(p + "/"));
